import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { CurrentValue } from '..';
import { userSelectors } from '../../../../store/modules/user';
import Control from '../Control';
import { Controls, FieldDirection } from '../ControlsPanel';
import { GroupSize } from '../ControlsPanel/controlGroupsData';
import { Row } from '../Wrapper';

import Wrapper, { ControlGroupSubtitle } from './Wrapper';
import getControlTooltip from './tooltips';

type ControlGroupProps = {
  flow: FieldDirection;
  size: GroupSize;
  subtitle: string;
} & ControlsListProps;

type ControlsListProps = {
  controls: Controls[];
  onChange: (value: CurrentValue) => void;
};

const getRowSize = (controls: Controls[]) =>
  controls.length === 1 ? 'full' : 'half';

const ControlList: FC<ControlsListProps> = ({ controls, onChange }) => {
  const profile = useSelector(userSelectors.selectUserProfile);
  return (
    <>
      {controls.map(control => (
        <Row
          key={`${control.id}/${control.controlValue}`}
          size={getRowSize(controls)}
        >
          <Control
            {...control}
            onChange={onChange}
            renderTooltip={getControlTooltip(control, profile)}
          />
        </Row>
      ))}
    </>
  );
};

const ControlGroup: FC<ControlGroupProps> = ({
  flow,
  size,
  subtitle,
  ...listProps
}) => (
  <Wrapper flow={flow} size={size}>
    <ControlGroupSubtitle flow={flow}>{subtitle}</ControlGroupSubtitle>
    <ControlList {...listProps} />
  </Wrapper>
);

export default ControlGroup;
